import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  Button,
  Paper,
  Chip,
  RadioGroup,
  FormControl,
  Card,
  CardContent,
  CardActions,
} from "@material-ui/core";
import { MyPATDialog, MyPATIconButton } from "../../common";
import cx from "classnames";
import EditOutlined from "@material-ui/icons/EditOutlined";
import ViewTemplate from "./ViewTemplate";
import CreateTestTemplate from "./CreateTestTemplate";
import {
  CloseOutlined as CloseIcon,
  FileCopy as CopyIcon,
} from "@material-ui/icons";
import {
  testTemplateList,
  updateTestTemplate,
  showMsg,
  saveTestTemplate,
} from "../actions/testTemplateActions";
import { TypeOfGoalBody } from "../types/TypeOfGoalBody";
import { TestTemplateBody } from "../types/TestTemplateBody";
import ACLService from "../../acl/services/aclService";
import { getMandatoryQuestionCount, getMasterTestTypeDisplayName, getPropertyValue, getSectionLevelDisplayName, toShowJEEMainSpecificFields } from '../../../utils';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { PERMISSION_CONTENT_TYPES, TEST_TEMPLATE_TYPES, USER_RIGHTS } from "../../../constants/comman";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...theme.mixins.gutters(),
      width: "100%",
      maxWidth: "100%",
      paddingTop: theme.spacing.unit * 3,
      paddingBottom: theme.spacing.unit * 2,
    },
    headerActions: {
      textAlign: "right",
    },
    createContentButton: {
      marginRight: theme.spacing.unit * 4,
    },
    paper: {
      padding: theme.spacing.unit + 4,
      margin: theme.spacing.unit + 4 + "px 0",
	  boxShadow: '0 0 4px 0px #00000026',
	  cursor: 'pointer',
    },
	cursor:{
		cursor: 'pointer'
	},
    edit: {
      float: "right",
    },
    title: {
      paddingLeft: theme.spacing.unit,
      lineHeight: theme.spacing.unit * 4 + "px",
    //   fontWeight: theme.typography.fontWeightMedium,
      display: "inline-block",
    //   minWidth: 220,
      maxWidth: 520,
	  fontSize: 24,
	  fontweight: 600,
	  color: '#333',
	  textTransform: 'capitalize',
    },
    summary: {      
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: 16,
      "& span": {
        display: "inline-block",
        paddingLeft: "5px",
        fontSize: 16,
		fontWeight: theme.typography.fontWeightLight,
      },
	  "& strong":{
		fontWeight: 600
	  },
	  '&:not(:last-child)::after':{
			content: "''",
			width: 4,
			height: 4,
			background: '#DDDDDD',
			borderRadius: '50%',
			display: 'inline-block',
			margin: '0 10px',
			verticalAlign: 2,
		}
    },
    testMarks: {
      display: "inline-block",
      marginRight: theme.spacing.unit,
    },
    saveBtn: {
      boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.224892)",
      borderRadius: 2,
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "19px",
      letterSpacing: "0.5px",
      color: "#FFFFFF",
      background: "#1D7DEA",
      padding: "4px 22px",
      "&:hover": {
        background: "#1D7DEA",
      },
    },
    view: {
      float: "right",
      fontWeight: theme.typography.fontWeightRegular,
      lineHeight: theme.spacing.unit * 2 + "px",
      fontSize: theme.typography.fontSize,
      cursor: "pointer",
    },
    row: {
      paddingTop: theme.spacing.unit,
    },
    icon: {
      fontSize: 18,
      marginRight: theme.spacing.unit / 4,
    },
    courseChip: {
      borderRadius: theme.shape.borderRadius,
      marginLeft: theme.spacing.unit,
      verticalAlign: 13,
      fontSize: 12,
	  height: 21,
	  lineHeight: 21,
	  paddingTop: 3,
    },
	viewPopup:{
		marginTop: 6,
	},
    modalCopyIcon: {
      fontSize: 16,
      marginRight: "10px",
	},
	buttonEdit:{
		opacity: 0.4,
	},
	editBtn:{
		'& button':{
			padding: '4px 10px 4px 5px',
			height: 32,
		}
	},
	tempSummary:{
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: 10,
		marginLeft: 10,
	},
	tempHeading:{
		fontSize: 24,
		fontWeight: 400,
		color: '#333',
	},
	mr2:{
		marginRight: 10,
	},
	btnOutline:{
		color: '#1D7DEA',
		fontSize: 14,
		fontWeight: 400,
		padding: '8px 37px',
		borderRadius: 4,
		border: 'solid 1px #1D7DEA',
		'&:hover':{
			background: '#dbe6f3'
		}
	},
	btnPrimary:{
		background: '#1D7DEA',
		color: '#fff',
		fontSize: 14,
		fontWeight: 400,
		padding: '8px 37px',
		borderRadius: 4,
		'&:hover':{
			background: '#0a68d7'
		}
	}
  });

interface TemplateListProps extends WithStyles<typeof styles> {
  templatesList: TestTemplateBody[];
  testTemplateList: Function;
  typeOfGoal: TypeOfGoalBody[];
  showMsg: (msg: string, vari: string) => void;
  activeTSetting: any;
  userData: any;
  isPostExpiryDays: any;
  showLicenseExpiredDialog: any;
  toggleLicenseExpiredDialog: any;
  setLoggedInUser: any;
  selectedTemplateTypeFilter: any;
  onTemplateRuleEdit: Function;
  activeTestType: any;
}

interface TemplateListState {
  durationType: string;
  viewDialogOpen: boolean;
  isView: boolean;
  updateTestTesmplate: any;
  testTemplateReq: any;
  testDetailTemplate: any;
}

class TemplateList extends Component<TemplateListProps, TemplateListState>{

	constructor(props: TemplateListProps) {
		super(props);

		this.state = {
			durationType: "min",
			viewDialogOpen: false,
			testDetailTemplate: {},
			isView: false,
			updateTestTesmplate: {},
			testTemplateReq: {}
		};
	}
	errorMsg: any = {}
	componentDidMount() {
		this.props.setLoggedInUser();
	}



	formDialogCloseHandler = () => {
		this.setState({
			viewDialogOpen: false,
			isView: false
		});
	};

	viewCreateTemplate = (event: any) => {
		this.setState({
			isView: !this.state.isView
		})
	}

	editTestTemplate = (event: any, isView: boolean, index: number) => {
		event && event.stopPropagation && event.stopPropagation();
		if (this.props.isPostExpiryDays) {
			this.props.toggleLicenseExpiredDialog(true)
		} else {
			let updateTest = this.props.templatesList && this.props.templatesList.length > 0 ? this.props.templatesList[index] : {};

		//Keeping testTemplateReq with body so that if user don't update any field still we have the data 
		//and update
		this.setState({
			isView: isView,
			updateTestTesmplate: updateTest,
			testTemplateReq: updateTest
		});
		}
		
	}

	gotFromChild = (data: TestTemplateBody) => {
		this.setState({
			testTemplateReq: data
		});
	}

	openDetailsTemplate = (event: any, id: number) => {
		let detailTest = this.props.templatesList && this.props.templatesList.length > 0 ? this.props.templatesList[id] : {};
		this.setState({ viewDialogOpen: true, testDetailTemplate: detailTest });
	}

	updateTemplate = (event: any) => {
		event.preventDefault();
		const { testTemplateReq } = this.state
		if (testTemplateReq.sections) {
			testTemplateReq.sections.forEach((section: any, i: number)=>{
				// if there is no section name then it will take default Section + index
				section.name = section.name.trim() == '' ? 'Section ' + (i + 1) : section.name   
			})
		}
		if (this.validateTemplateForm(this.state.testTemplateReq)) {
			updateTestTemplate({...this.state.testTemplateReq, templateType: this.props.selectedTemplateTypeFilter})
				.then((isSave) => {
					this.props.onTemplateRuleEdit();
					this.viewCreateTemplate("");
				})
		} else {
			return false;
		}
	}

	//Same code is implemented at TemplateContent.tsx if you are changing at this same need to be changed at there also
	validateTemplateForm(reqB: any) {
		let requB: any = reqB;
		let errorC = this.test2(requB);
		if (errorC > 0) {
			let msg = "";

			if (this.errorMsg["name"]) {
				msg = 'Kindly provide name';
				this.props.showMsg(msg, 'error');
				return false;
			}

			if (this.errorMsg["courseId"]) {
				msg = 'Kindly provide goal';
				this.props.showMsg(msg, 'error');
				return false;
			}
			if (this.errorMsg.sections && this.errorMsg.sections.length > 0) {
					for(let i=0;i<this.errorMsg.sections.length;i++) {
						const ob = this.errorMsg.sections[i];
						if (ob['courseSyllabusId']) {
							msg = `Select section or enable autopick at section ${i + 1}`;
							this.props.showMsg(msg, 'error');
							return false;
						}
						if (ob['name']) {
							msg = `Enter section name at section ${i + 1}`;
							this.props.showMsg(msg, 'error');
							return false;
						}
						if (ob["subSection"] && ob['subSection'].length > 0) {
								for(let j=0;j<ob["subSection"].length;j++) {
									const ob2 = ob["subSection"][j];
									if (ob2['name']) {
										msg = `Enter subsection name at subsection ${j + 1} of section ${i + 1}`;
										this.props.showMsg(msg, 'error');
										return false;
									}
									if (ob2['noOfQuestions']) {
										msg = `Select no of question at subsection ${j + 1} of section ${i + 1}`;
										this.props.showMsg(msg, 'error');
										return false;
									}
									if(ob2.mandatoryQuestionCount) {
										msg = `Select no of mandatory questions at subsection ${j + 1} of section ${i + 1}`;
										this.props.showMsg(msg, 'error');
										return false;
									}
									if (ob2['quesCodeAllowed']) {
										msg = `Select question type at subsection ${j + 1} of section ${i + 1}`;
										this.props.showMsg(msg, 'error');
										return false;
									}
							}
						}
				}
			}
		} else {
			return true;
		}
	}

	//Same code is implemented at TemplateContent.tsx if you are changing at this same need to be changed at there also
	test2(requB: any) {
		let errorCount = 0;
		this.errorMsg = {};
		let testSectionLevel = requB['testSectionLevel'];
		for (let i in requB) {

			if (['name', 'courseId'].includes(i)) {
				if (_.isEmpty(requB['name'])) {
					this.errorMsg['name'] = "required *";
					errorCount++;
				}
				//Since for none we don't need goalId
				if (testSectionLevel != 'none' && _.isEmpty(requB['courseId'])) {
					this.errorMsg['courseId'] = "required *";
					errorCount++;
				}
			}
			//For sections
			if (Array.isArray(requB[i])) {

				requB[i].forEach((ob: any, j: number) => {
					//create an empty array with sections
					if (!this.errorMsg['sections'])
						this.errorMsg['sections'] = [];

					if (!this.errorMsg['sections'][j]) {
						this.errorMsg['sections'][j] = {};
					}

					//Since this is in OR conditions
					let isAutoPick = ob["autoPickSelection"];
					let courseSyllabusId = ob["courseSyllabusId"];
					if (!isAutoPick && _.isEmpty(courseSyllabusId) && testSectionLevel != 'none') {
						this.errorMsg['sections'][j]["courseSyllabusId"] = "required *";
						errorCount++;
					}
					if (!ob["name"] && testSectionLevel == 'none') {
						this.errorMsg['sections'][j]["name"] = "required *";
						errorCount++;
					}

					ob["subSection"].forEach((ob2: any, l: number) => {
						//Loop over subsections and initilize with empty array
						if (!this.errorMsg['sections'][j]['subSection']) {
							this.errorMsg['sections'][j]['subSection'] = [];
						}
						if (!this.errorMsg['sections'][j]['subSection'][l]) {
							this.errorMsg['sections'][j]['subSection'][l] = {};
						}
						if (!ob2.name) {
							this.errorMsg['sections'][j]['subSection'][l]["name"] = "required *";
							errorCount++;
						}
						if (parseInt(ob2.noOfQuestions) == 0) {
							this.errorMsg['sections'][j]['subSection'][l]["noOfQuestions"] = "required *";
							errorCount++;
						}
						if(ob2.mandatoryQuestionCount === 0) {
							this.errorMsg['sections'][j]['subSection'][l]["mandatoryQuestionCount"] = "required *";
							errorCount++;
						}
						if (testSectionLevel != 'none' && ob2.quesCodeAllowed == -1) {
							this.errorMsg['sections'][j]['subSection'][l]["quesCodeAllowed"] = "required *";
							errorCount++;
						}

					})
				})

			}
		}
		return errorCount;
	}

	getGoalName(id: any) {
		let g = this.props.typeOfGoal.filter(o => o.groupId == id || o._id === id);
		return g && g.length > 0 ? g[0].courseType.name : "" || "";
	}

	editOnView(event: any, template: TestTemplateBody) {
		this.setState({
			viewDialogOpen: false,
			isView: true,
			updateTestTesmplate: template,
			testTemplateReq: template
		});
	}

	makeACopy(e: any, template: TestTemplateBody) {
		template.name += "_copy";
		template.templateType = this.props.selectedTemplateTypeFilter;
		saveTestTemplate(template)
			.then((isSave) => {
				this.props.testTemplateList(0, '', (this.props.activeTestType || {})._id);
				this.props.showMsg(`Copied successfully with name ${template.name}`, 'success');
				this.setState({
					viewDialogOpen: false,
					isView: false,
				});
			})
	}

	render() {
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		const { classes, templatesList, selectedTemplateTypeFilter } = this.props;
		const { durationType, viewDialogOpen, testDetailTemplate, isView, updateTestTesmplate } = this.state;
		return (
			<>
				{
					_.map(templatesList, (filterData, i) => {
						const showJEEMainSpecificFields = toShowJEEMainSpecificFields(filterData)
						let mandatoryQuestionCount = 0;
						// if(showJEEMainSpecificFields) {
							mandatoryQuestionCount = getMandatoryQuestionCount(filterData);
						// }
						if(!filterData._id) {
							return null;
						}
						return (
							<Paper key={i} className={[classes.paper, classes.cursor].join(' ')} elevation={1} onClick={() => this.openDetailsTemplate(this, i)}>
								<Grid container spacing={8} alignItems="center">
									<Grid item xs>
										<Typography className={classes.title} variant="h5" noWrap title={filterData.name}>{filterData.name}</Typography>
										{
											!_.isEmpty(filterData.groupId) ?
												<Chip color="primary" label={this.getGoalName(filterData.groupId)} className={classes.courseChip} variant="outlined" />
												:
												""
										}
									</Grid>
										<Grid item xs="auto" className={classes.edit}>
											<div style={{ float: "right" }} className={classes.editBtn}>
												<Button
													disabled={!ACLService.checkModulePermission(selectedTemplateTypeFilter === TEST_TEMPLATE_TYPES.DEFAULT ? PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE : PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, USER_RIGHTS.EDIT) }
													classes={{ disabled: classes.buttonEdit }}
													onClick={(event) => this.editTestTemplate(event, true, i)}
													variant="outlined"
													size="medium">
													<EditOutlined className={classes.icon} />
													<Typography
														className={classes.view} variant="caption">Edit</Typography>
												</Button>
											</div>
										</Grid>
								</Grid>
								<Grid container className={classes.tempSummary}>
										<Typography className={classes.summary} variant="subtitle2"><strong>Summary:</strong>
											<Typography variant="caption">{filterData.noOfSections} Sections, {filterData.subSectionsCount} Sub-sections</Typography>
										</Typography>
										<Typography className={classes.summary} variant="subtitle2"><strong>Test Duration:</strong>
											<Typography variant="caption">{filterData.testDurationNumber} mins</Typography>
										</Typography>
										<Typography className={classes.summary}><strong>Marks:</strong>
											<Typography variant="caption">{filterData.totalMarks}</Typography>
										</Typography>
										<Typography className={classes.summary}><strong>Total Ques:</strong>
											<Typography variant="caption">{filterData.questionsCount}</Typography>
										</Typography>
									{(
										<Typography className={classes.summary}><strong>Mandatory Ques:</strong>
											<Typography variant="caption">{mandatoryQuestionCount}</Typography>
										</Typography>
									)}
									{ filterData.testTypeCode && <Typography className={classes.summary} variant="subtitle2"><strong>Master Test Type:</strong>
										<Typography variant="caption">{getMasterTestTypeDisplayName(filterData.testTypeCode)}</Typography>
									</Typography>}
									{filterData.testSectionLevel && <Typography className={classes.summary} variant="subtitle2"><strong>Sections Level:</strong>
										<Typography variant="caption">{getSectionLevelDisplayName(filterData.testSectionLevel)}</Typography>
									</Typography>}
								</Grid>
							</Paper>

						)
					})
				}

				<MyPATDialog
					dialogOpen={viewDialogOpen}
					customButtonVariant="withoutBorderCloseIcon"
					onDialogClose={this.formDialogCloseHandler.bind(this)}
					otherDialogProps={otherDialogProps}
					customDialogTitle={
						<>
							<Grid container justify="space-between" alignItems="center">
								<Grid item container xs>
									<Typography variant="h5" noWrap className={classes.title}>{testDetailTemplate.name}</Typography>
									{
										!_.isEmpty(testDetailTemplate.courseId) ?
											<Chip color="primary" label={this.getGoalName(testDetailTemplate.groupId)} variant="outlined" className={[classes.courseChip, classes.viewPopup].join(' ')} />
											:
											""
									}
								</Grid>

								<Grid item xs="auto">
									<Typography variant="body1" className={classes.testMarks}>
										<strong>Marks:</strong> {testDetailTemplate.totalMarks}
									</Typography>
                    <Button variant="outlined"
					className={classes.mr2}
                      disabled={!ACLService.checkModulePermission("rule", "create")}
											onClick={() => this.makeACopy(this, testDetailTemplate)}
										>
											<CopyIcon className={classes.modalCopyIcon} /> Duplicate
                                        </Button>
									
									<MyPATIconButton buttonVariant="withoutBorderCloseIcon"
										onClick={this.formDialogCloseHandler.bind(this)}>
										<CloseIcon />
									</MyPATIconButton>
								</Grid>
							</Grid>
						</>
					}
					customDialogActions={
						<Grid>
							<Button classes={{ root: classes.btnOutline}}
								disabled={!ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.TEMPLATE_SETTINGS, USER_RIGHTS.EDIT)}
								onClick={() => this.editOnView(this, testDetailTemplate)}
							>
								Edit
							</Button>
							<Button classes={{ root: classes.btnPrimary }}
								onClick={this.formDialogCloseHandler.bind(this)}
							>
								Okay
							</Button>
						</Grid>
					}
				>
					<ViewTemplate templateDetails={testDetailTemplate} />
				</MyPATDialog>

				<MyPATDialog
					dialogOpen={isView}
					otherDialogProps={otherDialogProps}
					onDialogClose={this.formDialogCloseHandler.bind(this)}
					variantHeader="leftHeader"
					customButtonVariant="withoutBorderCloseIcon"
					customDialogTitle={
						<>
							<Grid container justify="space-between" alignItems="center">

								<Grid item xs={5}>
									<Grid container alignItems="flex-start">
										<Typography noWrap className={classes.tempHeading}>{updateTestTesmplate.name}</Typography>
									</Grid>
								</Grid>

								<Grid item xs="auto">
									<Typography variant="body1" className={classes.testMarks}>
										<strong>Marks:</strong> {updateTestTesmplate.totalMarks}
									</Typography>
									&nbsp;&nbsp;
									{updateTestTesmplate._id &&
										<Button variant="outlined"
											onClick={() => this.makeACopy(this, updateTestTesmplate)}
										>
											<CopyIcon className={classes.modalCopyIcon} /> Duplicate
                                        </Button>
									}
									&nbsp;&nbsp;
									<MyPATIconButton buttonVariant="withoutBorderCloseIcon"
										onClick={this.viewCreateTemplate.bind(this)}>
										<CloseIcon />
									</MyPATIconButton>
								</Grid>
							</Grid>
						</>
					}
					customDialogActions ={
						<Grid>
							<Button  classes={{ root: classes.btnOutline}}
								onClick={this.formDialogCloseHandler.bind(this)}
							>
								Cancel
							</Button>
							<Button  classes={{ root: classes.btnPrimary}}
								onClick={this.updateTemplate.bind(this)}
							>
								Save
							</Button>

						</Grid>
					}
				>
					<CreateTestTemplate transferToParent={this.gotFromChild} updateTemplate={updateTestTesmplate} activeTSetting={this.props.activeTSetting} />
				</MyPATDialog>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
  // map state to props here
  typeOfGoal: _.get(state, "testTemplate.goal.list", {}),
  userData: state.loginData.userData,
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays,
  activeTestType: getPropertyValue(state, 'testTemplate.testTemplateType.activeTestType', {})
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      testTemplateList,
	  showMsg,
	  toggleLicenseExpiredDialog,
	  setLoggedInUser
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // @ts-ignore
)(withStyles(styles)(TemplateList));
